import { Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import Style from './style';
import Frame from '../frame';
import Metrics from '../metrics';
import { useChartHelperColumns } from '../../../../../../../helpers/Charts';
import { filtersData } from '../../sections/information-contributions/helper';
import { getPopupContainer } from '../../../../../../../helpers/popUp';

const Identification = ({
  t = (s) => s,
  data,
  language,
  canFetch = false,
  valToResetFilters = {},
  PmeProjectGetWithFilters = () => { },
  settings,
}) => {
  const [activeFilter, setActiveFilter] = useState(
    settings?.defaultFilters?.informationContributions || 'year'
  );
  const [metricsValues, setMetricsValues] = useState([
    { color: "#7FAFD4", label: "Locations", type: 'locations', toggled: true },
    { color: "#BEB7DA", label: "Stakeholders", type: 'stakeholders', toggled: true },
    { color: "#8DD5C9", label: "Events", type: 'events', toggled: true },
    { color: "#8DD5C9", label: "Events EMPTY", type: 'empty', toggled: true },
  ]);
  const [frameActions, setFrameActions] = useState(null);


  useEffect(() => {
    if (settings?.defaultFilters?.informationContributions) {
      setActiveFilter(settings?.defaultFilters?.informationContributions);
    }
  }, [settings]);

  const _data = useMemo(() => data ? data.map((d) => ({
    ...d,
    items: {
      locations: d.items?.locations || 0,
      stakeholders: d.items?.stakeholders || 0,
      events: d.items?.events || 0,
    }
  })) : null, [data]);

  const isEmpty = useMemo(() => _data ? !_data.find((d) => d.total) : false, [_data]);

  const { container } = useChartHelperColumns({
    t,
    metricsValues,
    data: _data,
    type: 'identification',
    isEmpty,
  });

  useEffect(() => {
    if (frameActions) {
      if (_data === null) {
        frameActions.loading(true);
      } else {
        frameActions.loading(false);
      }
    }
  }, [frameActions, _data]);

  useEffect(() => {
    if (canFetch) {
      PmeProjectGetWithFilters({
        widget: 'infromationContributorsIdentification',
        filters: {
          periods: activeFilter,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valToResetFilters, canFetch, language, activeFilter]);

  return (
    <Frame
      onInit={actions => setFrameActions(actions)}
      title={t('Information Contributions')}
      optionalHeaderContent={(
        <Select
          style={{ width: 100 }}
          {...getPopupContainer()}
          value={activeFilter}
          onChange={(val) => setActiveFilter(val)}
          className="custom-select"
        >
          {filtersData.periods.map((v, i) => (
            <Select.Option
              key={`identification-${v.value}-${i}`}
              value={v.value}
            >
              {t(v.label)}
            </Select.Option>
          ))}
        </Select>
      )}
    >
      <Style>
        <Metrics
          noBorders
          fullRoundedIdentifiers
          t={t}
          title={null}
          metricsValues={metricsValues}
          setMetricsValues={setMetricsValues}
        />
        <div ref={container} style={{ width: '100%' }} />
      </Style>
    </Frame>
  );
};

export default Identification;
